import React from 'react';
import { CircularProgress, Grid, Link } from '@mui/material';
import GadgetLoader from '../../Loaders/GadgetLoader';
import EnhancedDataGrid from '../../Common/EnhancedDataGrid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import RouteToEmployeeIcon from '@mui/icons-material/AssignmentInd';
import { formatNumber, defaultStringIfNullOrEmpty, getDisplayName } from '../../Common/Utilities';



const BottomLeftGadget = ({
	xsVal,
	gridCss,
	keyVal,
	thisRef,
	fontStyle,
	cellStyle,
	hasSearchedOnce
}) => {
	const { modelDefId } = thisRef.state;

	const renderSmartText = React.useCallback((text) => {
		const value = (text ?? '').toString();
		const hasWhitespace = /\s/.test(value);

		const style = hasWhitespace
			? {
				display: '-webkit-box',
				WebkitLineClamp: 2,
				WebkitBoxOrient: 'vertical',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				wordBreak: 'normal',
				overflowWrap: 'break-word',
				whiteSpace: 'normal',
				lineHeight: 1.3,
			}
			: {
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				display: 'block',
				lineHeight: 1.3,
			};

		return (
			<Tooltip title={value} placement="top-start">
				<span style={style}>{value}</span>
			</Tooltip>
		);
	}, []);

	const isWeeksToFilterSearchActive = React.useMemo(() => {
		const text = thisRef.state.filterText[3];
		const prev = thisRef.state.prevSearchText[3];
		const weeks = thisRef.state.weeksToFilter3;
		return (
			(text !== '' && weeks !== 0) ||
			(weeks === 0 && text === prev && text.trim() !== '')
		);
	}, [thisRef.state.filterText[3], thisRef.state.prevSearchText[3], thisRef.state.weeksToFilter3]);
	const serverProps = React.useMemo(() => { return thisRef.state.serverMode[3] && thisRef.state.weeksToFilter3 === 0 ? { filterMode: "server" } : {} }, [thisRef.state.serverMode[3], thisRef.state.weeksToFilter3])
	const toolTipMessage = React.useMemo(() => { return (thisRef.state.serverMode[3] && thisRef.state.weeksToFilter3 === 0) ? thisRef.toolTipMessage : '' }, [thisRef.state.weeksToFilter3, thisRef.state.serverMode[3]]);


	return <Grid item xs={xsVal} className="fade-in" key={keyVal}>
		<div style={{ position: "relative", ...gridCss }}>
			<GadgetLoader loading={thisRef.state.gadgetLoading[3]} />
			<EnhancedDataGrid
				rows={thisRef.state.pendingApprovalInvoices}
				gridRef={thisRef.invoicePendingApprovalGridRef}
				disableColumnMenu
				pagination
				title="Pending Approval"
				toolTipMessage={toolTipMessage}
				hasSearchedOnce={hasSearchedOnce}
				pageSize={thisRef.state.pageSize}
				{...serverProps}
				onSearchFocus={() => thisRef.handleSearchFocus(3)}
				searchCallback={
					null
					//(searchText) => {
					//const trimmedText = (searchText || "").trim();
					//const prevText = thisRef.state.prevSearchText[3];

					//if (trimmedText === "" && prevText !== "") {
					//	thisRef.setState((prevState) => ({
					//		prevSearchText: {
					//			...prevState.prevSearchText,
					//			3: ""
					//		}
					//	}), () => {
					//		thisRef.fetchDashboard(3, thisRef.state.weeksToFilter3 ?? 0, searchText);
					//	});
					//	return;
					//}

					//if (trimmedText !== "" && trimmedText !== prevText) {
					//	thisRef.setState((prevState) => ({
					//		prevSearchText: {
					//			...prevState.prevSearchText,
					//			3: trimmedText
					//		}
					//	}), () => {
					//		thisRef.fetchDashboard(3, thisRef.state.weeksToFilter3 ?? 0, searchText);
					//	});
					//}
					//}
				}
				//showSearchTooltip={
				//	thisRef.state.switchToFullScreen &&
				//	thisRef.state.showGadget === 3 &&
				//	thisRef.state.showSearchTooltip
				//}
				showSearchTooltip={false}
				setFilterText={(text) => { thisRef.setFilterText(3, text) }}
				filterText={thisRef.state.filterText[3]}
				isWeeksToFilterSearchActive={isWeeksToFilterSearchActive}
				sortModel={thisRef.state.sortModel[3]}
				onSortModelChange={(model) => thisRef.setSortModel(3, model)}
				rowsPerPageOptions={thisRef.state.rowsPerPage}
				footerMessage={''}
				getRowClassName={
					thisRef.getDashboardRowClassName
				}
				onRowClick={(params, event) => thisRef.handleDashboardRowClick(3, params, event)}
				columns={[
					...((thisRef.isAdmin && thisRef.state.isExpanded) ? [{
						headerName: 'Customer Name',
						field: 'clientName',
						flex: 1,
						cellStyle: cellStyle,
						renderCell: (rowData) => renderSmartText(rowData?.row?.clientName || '')
					}] : []),
					{
						headerName: 'Vendor Name',
						field: 'vendorName',
						cellStyle: cellStyle,
						flex: 1,
						renderCell: (rowData) => renderSmartText(thisRef.displayVendorName(rowData.row))
					},
					{
						headerName: 'Invoice Number',
						field: 'invoiceNumber',
						flex: 1,
						cellStyle: cellStyle,
						renderCell: (rowData) => renderSmartText(rowData?.row?.invoiceNumber || '')
					},
					{
						headerName: getDisplayName('User Status'),
						field: 'invoiceUserStatus',
						width: 100,
						minWidth: 100,
						cellStyle: cellStyle,
						renderCell: (params) => {
							const value = params.value || '';

							return (
								<Tooltip title={value} placement="top-start">
									<span
										style={{
											display: 'block',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											whiteSpace: 'nowrap',
											width: '100%',
											cursor: 'default'
										}}
									>
										{value}
									</span>
								</Tooltip>
							);
						}
					},
					...((thisRef.isAdmin && thisRef.state.isExpanded && modelDefId === 1) ? [{
						headerName: 'Campaign Name',
						field: 'campaignName',
						flex: 1,
						cellStyle: cellStyle,
						renderCell: (rowData) => renderSmartText(rowData?.row?.campaignName || '')
					}] : []),
					...((thisRef.isAdmin && thisRef.state.isExpanded && modelDefId === 2) ? [{
						headerName: 'Level2 Key',
						field: 'level2Keys',
						flex: 1,
						cellStyle: cellStyle,
						renderCell: (rowData) => renderSmartText(rowData?.row?.level2Keys || '')
					}] : []),
					...((thisRef.state.isExpanded) ? [{
						headerName: 'Net Amount',
						field: 'netAmount',
						type: 'currency',
						align: 'right',
						headerAlign: 'right',
						renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.netAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
						flex: 1
					}] : []),
					...((thisRef.state.isExpanded) ? [{
						headerName: 'Tax Amount',
						field: 'taxAmount',
						type: 'currency',
						align: 'right',
						headerAlign: 'right',
						renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.taxAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
						flex: 1
					}] : []),
					{
						headerName: 'Total Invoice Amt',
						field: 'totalAmount',
						type: 'currency',
						flex: 1,
						align: 'right',
						headerAlign: 'right',
						headerStyle: {
							textAlign: 'right',
						},
						cellStyle: {
							paddingRight: 8,
							fontSize: 12
						},
						renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.totalAmount) + " " + rowData.row.currencyCode}</span>
					},
					{
						headerName: 'Invoice Date',
						field: 'invoiceDate',
						flex: 1,
						type: 'date',
						valueGetter: ({ value }) => value || '',
						valueFormatter: ({ value }) => {
							if (!value) return '';
							const d = new Date(value);
							return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
						},
						cellStyle: cellStyle
					},
					{
						headerName: 'Assigned To',
						field: 'assignedTo',
						flex: 1,
						cellStyle: cellStyle,
						renderCell: rowData => {
							if (rowData.row.assignedTo && rowData.row.assignedTo.split('|').length > 1)
								return <div>
									<Tooltip
										title={
											<span style={{ whiteSpace: 'pre-line' }}>{rowData.row.assignedTo.split('|').join("\n")}</span>
										}>
										<Link>{rowData.row.assignedTo.split('|')[0]} ...</Link>
									</Tooltip>
								</div>;
							return rowData.row.assignedTo;
						}
					},
					{
						headerName: 'Previously Approved',
						field: 'approvedBy',
						flex: 1,
						cellStyle: cellStyle,
						renderCell: (rowData) => renderSmartText(rowData?.row?.approvedBy || '')
					},
					{
						headerName: 'Status',
						field: 'status',
						flex: 1,
						cellStyle: cellStyle,
						minWidth: 140,
						renderCell: (rowData) => {
							const row = rowData.row;
							const isReloading = thisRef.isInvoiceRowReloading(row.invoiceDocumentId);
							const statusText = row.status;

							return (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										width: '100%',
										gap: isReloading ? 6 : 0, // 👈 no gap when spinner is absent
									}}
								>
									<Tooltip title={statusText || ''} placement="top-start">
										<span
											style={{
												flex: 1,
												display: '-webkit-box',
												WebkitLineClamp: 2,
												WebkitBoxOrient: 'vertical',
												overflow: 'hidden',
												wordBreak: 'normal',
												overflowWrap: 'break-word',
												textOverflow: 'ellipsis',
												whiteSpace: 'normal',
												lineHeight: 1.3,
											}}
										>
											{statusText}
										</span>
									</Tooltip>

									{isReloading && (
										<div
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												flexShrink: 0,
											}}
										>
											<CircularProgress size={18} />
										</div>
									)}
								</div>
							);
						}
					}
					//{
					//	headerName: 'Review Invoice',
					//	field: 'reviewInvoice',
					//	cellStyle: cellStyle,
					//	flex: 1, resizable: false, sortable: false,
					//	renderCell: rowData => thisRef.displayActions(rowData.row)
					//}
				]}
				customcomponent={
					<>
						{thisRef.getOpenInFullScreenButton(3)}
						{thisRef.getRefreshButton(3)}
						{thisRef.isAdmin && thisRef.state.isExpanded && thisRef.state.isAllowApprovalRoutingSetup && (
							<IconButton
								variant="contained"
								onClick={thisRef.bulkApprovalRouting_clickHandler}
								size="small"
								style={{ float: 'right', zIndex: 1, marginTop: 10 }}
							>
								<Tooltip key={1} title={'Route for Approval'}>
									<RouteToEmployeeIcon key={2} />
								</Tooltip>
							</IconButton>
						)}
						{thisRef.isAdmin && !thisRef.state.isExpanded && thisRef.state.isAllowApprovalRoutingSetup && (
							<Link
								href="#"
								onClick={thisRef.overrideRouting_clickHandler}
								style={{
									marginLeft: 5,
									marginRight: 5,
									marginTop: 16,
									float: 'right',
									textDecoration: 'none',
									fontSize: 14,
									fontWeight: 'bold',
									cursor: 'pointer',
									display: 'inline_block',
									padding: '3px 2px 3px 2px'
								}}
								onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.03)'}
								onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
							>
								Override Routing
							</Link>
						)}
						{thisRef.getWeeksToFilterDropDown(3)}
						{thisRef.getSearchButton(3)}
					</>
				}
				options={{
					minBodyHeight: 320,
					maxBodyHeight: 320,
					headerStyle: fontStyle,
					searchFieldStyle: fontStyle
				}}
				quickFilterDebounceMs={thisRef.getQuickFilterDebounceMs(3)}
				onSelectionChange={(thisRef.state.isExpanded && thisRef.isAdmin) ? rows => { thisRef.selectedRows = rows; } : null}
				getRowId={row => row.rowId}
				disableRowSelectionOnClick
			/>

		</div>
	</Grid>

};

export default BottomLeftGadget;